import ContainerStyle from './style.js';

var {
  Container
} = ContainerStyle;

export { Container };
